import { useLocation } from 'react-router-dom';
import { useReadersCatalogSearch } from '@/contexts/ReadersCatalogSearchContext';
import { NavbarSearchPopoverControl } from '@/components/Layout/NavbarSearchPopoverControl';

export function ReadersSearchNavbarControl() {
  const location = useLocation();
  const isReadersRoute = location.pathname === '/readers';
  const { searchInput, setSearchInput, clearSearch } = useReadersCatalogSearch();

  if (!isReadersRoute) return null;

  return (
    <NavbarSearchPopoverControl
      value={searchInput}
      onChange={setSearchInput}
      onClear={clearSearch}
      placeholder="Поиск по чтецам..."
      ariaLabel="Поиск по таблице чтецов"
      dialogTitle="Поиск по чтецам"
    />
  );
}
